import React, { useEffect, useState } from "react";
import { Instagram, Volume2, VolumeX } from "lucide-react";
import Starfield from "./Starfield";
import ParticlePortrait from "./ParticlePortrait";
import CursorTrail from "./CursorTrail";
import WaitlistDialog from "./WaitlistDialog";
import useAmbientAudio from "../hooks/useAmbientAudio";

const IG_URL = "https://instagram.com/getsoundie";

export default function Landing() {
  const [mounted, setMounted] = useState(false);
  const { enabled, toggle, levelRef } = useAmbientAudio();

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);

  return (
    <main className="soundie-page">
      <Starfield />
      <CursorTrail />

      {/* Header */}
      <header className="soundie-header">
        <div className="brand">
          <img
            className="brand-logo"
            src="/soundie-logo.webp"
            alt="Soundie"
            width="132"
            height="44"
          />
        </div>
        <div className="header-actions">
          <button
            className="sound-toggle"
            onClick={toggle}
            aria-label={enabled ? "Turn ambient sound off" : "Turn ambient sound on"}
            aria-pressed={enabled}
          >
            {enabled ? <Volume2 size={19} strokeWidth={1.5} /> : <VolumeX size={19} strokeWidth={1.5} />}
          </button>
          <a
            className="ig-link"
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Soundie on Instagram"
          >
            <Instagram size={21} strokeWidth={1.5} />
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="soundie-hero">
        <div className={`hero-copy ${mounted ? "in" : ""}`}>
          <p className="eyebrow" style={{ transitionDelay: "0ms" }}>
            SOUND, DISCOVERED
          </p>
          <h1 className="headline" style={{ transitionDelay: "100ms" }}>
            Where local talent<br />becomes unforgettable.
          </h1>
          <p className="subcopy" style={{ transitionDelay: "200ms" }}>
            Soundie connects artists, venues, and communities &mdash; turning
            everyday moments into live music experiences.
          </p>
          <div className="cta-row" style={{ transitionDelay: "300ms" }}>
            <WaitlistDialog
              trigger={
                <button className="cta-pill primary">
                  Join the waitlist <span className="arrow">&rarr;</span>
                </button>
              }
            />
            <a className="cta-pill ghost" href={IG_URL} target="_blank" rel="noopener noreferrer">
              Follow along
            </a>
          </div>
        </div>

        <div className="hero-portrait">
          <ParticlePortrait levelRef={levelRef} />
        </div>
      </section>

      {/* Giant ghosted wordmark */}
      <div className="ghost-wordmark" aria-hidden="true">
        SOUNDIE
      </div>
    </main>
  );
}
